// React i hooks
import { memo } from "react";

// Tipovi i konstante
import { LeasingSearchResultsProps } from "./types";
import { initialDataWithPagination } from "services/api/consts";
import { CALCULATION_LEASING_SEARCH_COLUMNS } from "./consts";

// UI komponente
import { TableSearch } from "ui/components/Table/TableSearch";


const LeasingSearchResults: React.FC<LeasingSearchResultsProps> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
  } = props;


  return (
    <>
      <TableSearch
        columns={CALCULATION_LEASING_SEARCH_COLUMNS}
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
      />
    </>
  );
};
export default memo(LeasingSearchResults);
